import React from "react";
//Limitless impirts
import { DevLoggingProvider } from "../../common/hooks/dev-logging/DevLoggingContext";
import { NotificationContextProvider } from "../../common/hooks/notification/NotificationContext";
import { CustomerHistoryContextProvider } from "../hooks/customer-history/CustomerHistoryContext";
import { CustomerContextProvider } from "../hooks/customer/CustomerContext";
import { CustomerMessageContextProvider } from "../hooks/customer-message/CustomerMessageContext";
import { GroupResponseTimeContextProvider } from "../hooks/group-response-time/GroupResponseTimeContext";
import { WebSocketsContextProvider } from "../../common/hooks/web-sockets/WebSocketsContext";
import { useCustomerWebSockets } from "../hooks/customer-web-sockets/CustomerWebSockets";

var CustomerLifecycleProvider = function CustomerLifecycleProvider(_ref) {
  var children = _ref.children,
      reactotron = _ref.reactotron,
      storageConfig = _ref.storageConfig,
      _ref$disableWebSocket = _ref.disableWebSockets,
      disableWebSockets = _ref$disableWebSocket === void 0 ? false : _ref$disableWebSocket,
      _ref$delayNonEssentia = _ref.delayNonEssentialCalls,
      delayNonEssentialCalls = _ref$delayNonEssentia === void 0 ? false : _ref$delayNonEssentia;

  var renderChildren = function renderChildren() {
    if (disableWebSockets) {
      return children;
    }

    return /*#__PURE__*/React.createElement(WebSocketsContextProvider, {
      eventProcessorHook: useCustomerWebSockets,
      shouldConnect: !delayNonEssentialCalls
    }, children);
  };

  return /*#__PURE__*/React.createElement(NotificationContextProvider, null, /*#__PURE__*/React.createElement(DevLoggingProvider, {
    reactotron: reactotron
  }, /*#__PURE__*/React.createElement(GroupResponseTimeContextProvider, {
    delayNonEssentialCalls: delayNonEssentialCalls
  }, /*#__PURE__*/React.createElement(CustomerContextProvider, {
    storageConfig: storageConfig
  }, /*#__PURE__*/React.createElement(CustomerHistoryContextProvider, null, /*#__PURE__*/React.createElement(CustomerMessageContextProvider, null, renderChildren()))))));
};

export default CustomerLifecycleProvider;